function LogoutContainer() {
    return (<div>You are now logged out</div>)
}

export default LogoutContainer